




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































interface departList {
    accountBookId: number;
    code: null;
    fullcode: null;
    hidden: string;
    id: number | string;
    leaf: null;
    name: string;
    no: string;
    pid: null;
    pno: null;
}
interface employeeList {
    accountBookId: number;
    dimDepartmentId: null;
    assDepartmentName: null;
    code: null;
    fullcode: null;
    hidden: string;
    id: number | string;
    licenseNo: string;
    licenseType: string;
    name: string;
    no: string;
    phone: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import idTypeList from "../data/idTypeList";
import Employee from "../components/Payroll/Employee";
import ExtraTaxVue from "../components/Payroll/ExtraTax.vue";
import NewAddEmployVue from "../components/Payroll/NewAddEmploy.vue";
import RuleCtrlVue from "../components/Payroll/RuleCtrl.vue";
import importSalaryVue from "../components/Payroll/importSalary.vue";
import PayRollTaxVue from "../components/Payroll/PayRollTax.vue";
import AssistingAccountVue from "./AssistingAccount.vue";
import SideNavVue from "../components/SideNav.vue";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        extraTax: ExtraTaxVue,
        "newAdd-employ": NewAddEmployVue,
        "rule-ctrl": RuleCtrlVue,
        "import-salary": importSalaryVue,
        "payroll-tax": PayRollTaxVue,
        "dim-account": AssistingAccountVue,
        "side-nav": SideNavVue,
    },
})
export default class Payroll extends Vue {
    filterVisible: boolean = false;
    ztList: DataTable.DropItem[] = [
        { id: "y", text: "未启用" },
        { id: "n", text: "启用" },
        { id: "", text: "全部" },
    ]
    sgList: DataTable.DropItem[] = [
        { id: "0", text: "雇员" },
        { id: "1", text: "其他" },
        { id: "2", text: "全部" },
    ]
    ryList: DataTable.DropItem[] = [
        { id: "0", text: "在职" },
        { id: "1", text: "离职" },
        { id: "2", text: "全部" },
    ]
    payData = {
        hidden: "",
        employType: "2",
        employStatus: "2",
    };
    resetFilter() {
        this.payData = {
            hidden: "",
            employType: "2",
            employStatus: "2",
        }
        this.$nextTick(() => {
            if (this.$refs.DimData)
                (<AssistingAccountVue>this.$refs.DimData).payChoose();
            this.filterVisible = false;
        })

    }
    confirmFilter() {
        if (this.$refs.DimData)
            (<AssistingAccountVue>this.$refs.DimData).payChoose();
        this.filterVisible = false;
    }
    showTax: boolean = false;
    //选中每页条数
    changeSize(size: number) {
        this.pageNation.pageSize = size;
        this.fetchData();
    }
    taxSuccess() {
        this.showTax = false;
        this.fetchData();
    }
    closeTax() {
        this.showTax = false;
        this.fetchData();
    }
    collectPeriod: string = this.$store.state.collectPeriod;
    taxChange() {
        this.showTax = true;
    }
    batchList(val: string) {
        if (val === "批量删除") this.multiDelete();
        else if (val === "下载") this.mainDownload();
        else if (val === "报税") this.taxChange();
        else if (val === "申报回写") this.reWrite();
    }
    isReWrite() {
        if(this.taxRecord) {
            if(this.period === this.collectPeriod && this.taxRecord.taxState === 4 && this.dataList.length > 0 && !this.isClose){
                return true
            }else return false
        }else return false
    }

    async reWrite() {
        await this.$confirm("亲,确定要 申报回写 选中的工资记录吗?", "温馨提示");
        const res = await Vue.axios.post("paysheet/rewrite", {
            id: this.$store.state.accountBook.id,
            endPeriod: this.period
        });
        this.$message(res.data.message);
        await this.fetchData();
    }
    //改变时间
    period: string = ""; // 日期
    changeDate(date: string) {
        this.period = date;
        this.fetchData(() => {
            this.focusNewName();
        });
    }

    focusPay() {
        this.isPayRoll = false;
        if (this.isPayRoll === false) this.listenerSelect();
    }

    otherQuery: string = "";
    accItem(val: any) {
        this.isPayRoll = !this.isPayRoll;
        if (this.$refs.DimData)
            (<AssistingAccountVue>this.$refs.DimData).fetchData(
                undefined,
                this.otherQuery
            );
        this.removeListener();
    }
    changeFetch() {
        if (this.$refs.DimData)
            (<AssistingAccountVue>this.$refs.DimData).page = 1;
            (<AssistingAccountVue>this.$refs.DimData).fetchData(
                undefined,
                this.otherQuery
            );
    }
    payImport() {
        if (this.$refs.DimData)
            (<AssistingAccountVue>this.$refs.DimData).showImport();
    }

    accountTypeName: string = "工资表";

    showAdd: boolean = false;
    endMonth: string = "";
    dataList: Salary.Salary[] = []; //表格数据
    licTypeEnum = idTypeList;
    pageNation: any = {
        currentPage: 1,
        pageSize: 10,
        totalElements: this.dataList.length,
    };

    scrollLeft: number = 0;
    ready: boolean = false;
    stepSize: number = 50;

    currScope: any = null;
    newRow: Salary.NewSalary[] = [
        {
            dimEmployeeId: "",
            salary: "",
        },
    ];

    curIndex: number = -1;

    searchQuery: string = "";

    get isClose() {
        let close = this.$store.state.accountBook.closePeriod;
        if (close != null && this.period != "") {
            let closeDate = new Date(
                close.substr(0, 4) + "-" + close.substr(4)
            ),
                curPeriod = new Date(
                    this.period.substr(0, 4) + "-" + this.period.substr(4)
                );
            return curPeriod <= closeDate;
        } else return false;
    }

    beforeDestroy() {
        this.removeListener();
    }

    removeListener() {
        let summaryTable: any = document.querySelector(
            ".data-table .summaryTable .el-table__body-wrapper"
        );
        let mainTable: any = document.querySelector(
            ".data-table .mainTable .el-table__body-wrapper"
        );
        let newTable: any = document.querySelector(
            ".data-table .newTable .el-table__body-wrapper"
        );
        if (summaryTable !== null) summaryTable.removeEventListener("scroll", this.syncScroll);
        if (mainTable !== null) mainTable.removeEventListener("scroll", this.syncScroll);
        if (newTable !== null) newTable.removeEventListener("scroll", this.syncScroll);
    }

    listenerSelect() {
        this.clearNewRow();
        setTimeout(() => {
            let summaryTable: any = document.querySelector(
                ".data-table .summaryTable .el-table__body-wrapper"
            );
            let mainTable: any = document.querySelector(
                ".data-table .mainTable .el-table__body-wrapper"
            );
            let newTable: any = document.querySelector(
                ".data-table .newTable .el-table__body-wrapper"
            );
            summaryTable.addEventListener("scroll", this.syncScroll);
            mainTable.addEventListener("scroll", this.syncScroll);
            newTable.addEventListener("scroll", this.syncScroll);
        }, 100);
    }

    mounted() {
        this.listenerSelect();
        // this.clearNewRow();
        // setTimeout(() => {
        //     let summaryTable: any = document.querySelector(
        //         ".data-table .summaryTable .el-table__body-wrapper"
        //     );
        //     let mainTable: any = document.querySelector(
        //         ".data-table .mainTable .el-table__body-wrapper"
        //     );
        //     let newTable: any = document.querySelector(
        //         ".data-table .newTable .el-table__body-wrapper"
        //     );
        //     summaryTable.addEventListener("scroll", this.syncScroll);
        //     mainTable.addEventListener("scroll", this.syncScroll);
        //     newTable.addEventListener("scroll", this.syncScroll);
        // }, 100);
    }
    // 获取从业类型
    getEmployType(id: number) {
        if (id === 1) {
            return "其他";
        } else {
            return "雇员";
        }
    }
    // 获取部门列表
    departList: departList[] = [];
    getDepartList(then?: any) {
        Vue.axios
            .post(`dim/account/find`, {
                accountBookId: this.$store.state.accountBook.id,
                dimAccountType: "部门",
            })
            .then((res) => {
                this.departList = res.data.dimDepartmentList;
                if (then) then();
            });
    }
    getDepart(id: string | number) {
        if (id != null) {
            for (let i = 0; i < this.departList.length; i++) {
                if ((<any>this.departList[i].id).toString() === id.toString())
                    return this.departList[i].name;
            }
        }
        return "";
    }

    lastMonth() {
        Vue.axios
            .post(
                `paysheet/copy?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}`
            )
            .then((res) => {
                this.$alert(res.data.message, "温馨提示");
                this.fetchData();
            });
    }
    // 获取员工列表
    employeeList: employeeList[] = [];
    getEmployList(then?: any) {
        Vue.axios
            .get(
                `dim/employee/find/hidden?accountBookId=${this.$store.state.accountBook.id}`
            )
            .then((res) => {
                this.employeeList = res.data.dimEmployeeList;
                if (then) then();
            });
    }
    isEmployType(id: string) {
        if (id != null) {
            if (id === "1") {
                return "其他";
            } else if (id === "0") {
                return "雇员";
            }
        }
        return "";
    }

    focusInput(e: any) {
        e.currentTarget.select();
    }

    updateScroll(distance: number, ele: any) {
        this.scrollLeft = distance;
        ele.scrollLeft = this.scrollLeft;
    }

    scrollEdit(event: any, index: number) {
        event.target.select();
        event.preventDefault();
        let tbody = document.querySelector(
            ".data-table .summaryTable .el-table__body-wrapper"
        );
        if (index > 1) {
            this.updateScroll(index * 100 - 100, tbody);
        } else {
            this.updateScroll(0, tbody);
        }
    }
    pressPension(e: KeyboardEvent, index: number) {
        if (e.keyCode === 37) {
            if (index === -1) {
                let input: any = document.querySelector(
                    ".newTable .el-table__fixed-body-wrapper input[name=newSalary]"
                );
                if (input != null) input.focus();
            } else {
                (<any>this.$refs["salaryInput-" + index]).focus();
            }
        } else {
            this.$utils.arrowPress(e);
        }
    }

    scroll(event: any) {
        //第一次滚动需要获取当前滚动位置
        let dataTable: any = document.querySelector(
            ".data-table .summaryTable .el-table__body-wrapper"
        );
        if (!this.ready) {
            this.scrollLeft = dataTable.scrollLeft;
            this.ready = true;
        }
        //firefox用detail反映滚动方向，而且方向和其他浏览器相反。其他浏览器用wheelDelta
        let direction = event.wheelDelta;
        //保证滚动到头的时候不再调用update函数
        if (this.scrollLeft < 0 && direction > 0) {
            return;
        }
        if (this.scrollLeft > 2550 && direction < 0) {
            return;
        }
        //根据鼠标滚动的方向确定是往左还是往右移动
        let distance = direction > 0 ? -this.stepSize : this.stepSize;
        this.update(distance, dataTable);
    }

    syncScroll(e: any) {
        let dataTable: any = document.querySelector(
            ".data-table .mainTable .el-table__body-wrapper"
        );
        let dataTableHead: any = document.querySelector(
            ".data-table .mainTable .el-table__header-wrapper"
        );
        let newTable: any = document.querySelector(
            ".data-table .newTable .el-table__body-wrapper"
        );
        let summaryTable: any = document.querySelector(
            ".data-table .summaryTable .el-table__body-wrapper"
        );
        summaryTable.scrollLeft = e.currentTarget.scrollLeft;
        dataTable.scrollLeft = e.currentTarget.scrollLeft;
        dataTableHead.scrollLeft = e.currentTarget.scrollLeft;
        if (!this.isClose) newTable.scrollLeft = e.currentTarget.scrollLeft;
    }

    update(distance: number, dataTable: any) {
        this.scrollLeft += distance;
        dataTable.scrollLeft = this.scrollLeft;
    }

    changePage(val: number) {
        this.pageNation.currentPage = val;
        this.fetchData();
    }

    getEmploy(id: string) {
        for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].id === id) {
                return this.employeeList[i];
            }
        }
        return new Employee();
    }

    summary: Salary.Salary[] = [];
    total: number = 0;
    taxRecord: any = null;
    fetchData(then?: any) {
        this.getEmployList();
        this.getDepartList();
        Vue.axios
            .get(
                `paysheet/find?page=${this.pageNation.currentPage - 1}&size=${this.pageNation.pageSize
                }&accountBookId=${this.$store.state.accountBook.id}&period=${this.period
                }&query=${this.searchQuery}&departmentId=${this.depStatus.id}`
            )
            .then((res) => {
                this.taxRecord = res.data.taxRecord;
                this.dataList = res.data.paySheetDtos.content;
                this.summary = [];
                this.summary[0] = res.data.total;
                this.total = res.data.paySheetDtos.totalElements;
                this.pageNation.totalElements =
                    res.data.paySheetDtos.totalElements;
                setTimeout(() => {
                    (<any>(
                        document.querySelector(
                            "#SalaryList .mainTable .el-table__fixed"
                        )
                    )).style.height = this.dataList.length * 40 + 65 + "px";
                    let all: any = document.querySelectorAll(
                        ".data-table .mainTable .el-table__fixed-body-wrapper tr"
                    );
                    all.forEach((val: any, i: number) => {
                        val.onmouseover = () => {
                            this.curIndex = i;
                        };
                    });
                    let nfAll: any = document.querySelectorAll(
                        ".data-table .mainTable .el-table__body-wrapper tr"
                    );
                    nfAll.forEach((val: any, i: number) => {
                        val.onmouseover = () => {
                            this.curIndex = i;
                        };
                    });
                    if (then) then();
                }, 300);
            });
    }

    delRow(id: string) {
        this.$confirm("亲,确定要删除选中的工资记录吗?", "温馨提示").then(() => {
            Vue.axios
                .delete(`paysheet/` + id + `/delete`, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                })
                .then((res) => {
                    this.fetchData();
                });
        });
    }

    focusNewName() {
        let input: any = document.querySelector(
            ".newTable .el-table__fixed-body-wrapper .newInput input"
        );
        if (input != null) input.focus();
    }

    blurSelect(select: any, e: any) {
        setTimeout(() => {
            (<any>this.$refs[select]).handleClose();
        }, 200);
        // Vue.prototype.arrowPress(e, false, true);
    }
    blurSalary(e: any, i: number) {
        if (i != this.dataList.length - 1) {
            // Vue.prototype.arrowPress(e);
        } else {
            this.focusNewName();
        }
    }
    blurDataLast(e: any, i: number) {
        if (i != this.dataList.length - 1) {
            // Vue.prototype.arrowPress(e);
        } else {
            this.focusNewName();
        }
    }

    focusEdit(e: KeyboardEvent, index: number) {
        // el-table__body-wrapper
        if (e.keyCode === 13) {
            if (index === -1) {
                let input: any = document.querySelector(
                    ".newTable .el-table__body-wrapper .newEdit input"
                );
                if (input != null) input.focus();
            } else {
                let input: any = document.querySelectorAll(
                    ".mainTable .el-table__body-wrapper .editFirst"
                )[index];
                if (input != null) input.focus();
            }
        }
    }

    employKeyDown(e: any, scope: any) {
        if (e.keyCode === 121) {
            this.addEmploy(scope);
        } else {
            this.$utils.arrowPress(e, false, true);
        }
    }

    backFocus() {
        if (this.currScope.$index != -1) {
            let eSel = <any>this.$refs["employSelect-" + this.currScope.$index];
            eSel.focus();
        } else {
            let input: any = document.querySelector(
                ".newTable .el-table__fixed-body-wrapper .newInput input"
            );
            if (input != null) input.focus();
        }
    }
    closeAdd() {
        this.showAdd = false;
        this.backFocus();
    }
    addSuccess(employee: Salary.IEmployee) {
        this.showAdd = false;
        this.getEmployList(() => {
            this.getDepartList(() => {
                this.$forceUpdate();
                this.backFocus();
            });
        });
    }

    addEmploy(scope: any) {
        this.showAdd = true;
        this.currScope = scope;
        this.$nextTick(() => {
            (<any>this.$refs.addEmploy).$refs.nameInput.focus();
        });
    }

    clearNewRow() {
        this.newRow = [
            {
                dimEmployeeId: "",
                salary: "",
                personalPension: "",
                personalMedical: "",
                personalUnemployment: "",
                personalHousingFund: "",
                // childEducationFee: "",
                totalChildEducationFee: "",
                // continueEducationFee: "",
                totalContinueEducationFee: "",
                // mortgageInterest: "",
                totalMortgageInterest: "",
                // rent: "",
                totalRent: "",
                // raiseElderly: "",
                totalRaiseElderly: "",
                companyPension: "",
                companyMedical: "",
                companyUnemployment: "",
                companyHousingFund: "",
                injuryInsurance: "",
                maternityInsurance: "",
                taxableIncome: "",
                personalIncomeTax: "",
                annualBonus: "",
                totalSalary: "",
                totalBabyCare:""
            },
        ];
    }

    lastPress(e: KeyboardEvent, index: number) {
        if (e.keyCode === 13) {
            if (index === -1) {
                this.addNewRow();
            } else {
                if (index != this.dataList.length - 1) {
                    (<any>this.$refs["employSelect-" + (index + 1)]).focus();
                } else {
                    this.focusNewName();
                }
            }
        } else {
            this.$utils.arrowPress(e, true);
        }
    }

    clickBody() {
        this.addNewRow(true);
    }
    // 新增行 新增数据
    addNewRow(noMes?: boolean) {
        if (this.newRow[0].dimEmployeeId != "" && this.newRow[0].salary != "") {
            let obj = Object.assign(this.newRow[0], {
                id: null,
                period: this.period,
                accountBookId: this.$store.state.accountBook.id,
                dimEmployeeId: this.newRow[0].dimEmployeeId,
            });
            Vue.axios
                .post(`paysheet/save`, obj)
                .then((res) => {
                    this.clearNewRow();
                    this.fetchData(this.focusNewName);
                })
                .catch(() => {
                    this.clearNewRow();
                });
        } else {
            if (!noMes) {
                this.$message("员工或收入未填写");
                this.focusNewName();
            }
        }
    }

    changeRow(row: any, index: number) {
        if (row.dimEmployeeId != "" && row.salary != "") {
            Vue.axios.post(`paysheet/save`, row).then((res) => {
                this.fetchData();
            });
        }
    }

    showRule: boolean = false;
    closeRule() {
        this.showRule = false;
    }
    changeSuccess() { }

    // 导入
    showImport: boolean = false;
    closeImport() {
        this.showImport = false;
    }
    importSuccess(res: any) {
        this.showImport = false;
        this.fetchData();
    }

    // 折叠行
    collapse: boolean = true;
    toggleCollapse() {
        this.collapse = !this.collapse;
    }

    // 测算个税
    reCalc() {
        Vue.axios
            .post(
                `tax/recalculate?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}`
            )
            .then((res) => {
                this.fetchData();
            });
    }

    // 筛选部门
    depStatus: any = {
        id: "",
    };
    allOpt: any = {
        id: "",
        name: "全部",
    };
    filterDep(dep: any) {
        this.depStatus = dep;
        this.pageNation.currentPage = 1;
        this.fetchData();
    }
    get showDepart() {
        return this.departList.length > 0;
    }

    getSummaryWidth() {
        //  165 : 620
        if (this.collapse) {
            if (this.showDepart) return 375;
            else return 285;
        } else {
            return 840;
        }
    }

    // 主表多选
    checkedSalary: Salary.Salary[] = [];
    changeSelect(selection: Salary.Salary[]) {
        this.checkedSalary = selection;
    }
    multiDelete() {
        if (this.checkedSalary.length > 0) {
            let id = "";
            this.checkedSalary.forEach((v, i, a) => {
                let cur = (<number>v.id).toString();
                if (a.length > 1 && i != a.length - 1) cur += ",";
                id += cur;
            });
            this.delRow(id);
        } else {
            this.$message({
                type: "warning",
                message: "请选择需要删除的工资",
            });
        }
    }
    // 下载
    mainDownload() {
        let url;
        const h = this.$createElement;
        this.$msgbox({
            title: "下载工资表",
            message: h("div", {}, [
                h("p", "1、选择‘用作原始凭证’，下载打印后，可用作工资表原始凭证。"),
                h("p", "2、选择‘用作查账导入’，下载完成更改数据信息后，可导入自然人电子税务局或财务软件。")
            ]),
            distinguishCancelAndClose: true,
            confirmButtonText: "用作原始凭证",
            cancelButtonText: "用作查账导入",
            showCancelButton: true,
            cancelButtonClass: "el-button--primary",
            center: true
        }).then(() => {
            url = `${Vue.axios.defaults.baseURL}export/printpaysheet?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&version=${version}&token=${this.$store.state.account.token}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
        }).catch(e => {
            if (e === "cancel") {
                url = `${Vue.axios.defaults.baseURL}export/paysheet?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&version=${version}&token=${this.$store.state.account.token}`;
                this.$store.dispatch("toggleDownload", true);
                this.$utils.sendToElectron("download", url);
            }
        });
    }
    isPayRoll: boolean = false;

    // 打印
    printPdf() {
        const url = `${Vue.axios.defaults.baseURL}export/pdf/pay/sheet?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&token=${this.$store.state.account.token}&version=${version}`;
        this.$utils.sendToElectron("download-pdf", url);
    }
}
